var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.354 1 19.232 4.12a6.422 6.422 0 0 0-3.753-1.198 6.485 6.485 0 0 0-6.48 6.479c0 3.208 2.339 5.872 5.4 6.39v2.343C11.339 18.65 9 21.315 9 24.52a6.485 6.485 0 0 0 6.479 6.48 6.485 6.485 0 0 0 6.478-6.479c0-3.205-2.34-5.87-5.4-6.387v-2.344c3.06-.518 5.4-3.182 5.4-6.39a6.48 6.48 0 0 0-1.2-3.753l3.122-3.121L22.354 1zM19.8 24.526a4.324 4.324 0 0 1-4.321 4.321 4.324 4.324 0 0 1-4.322-4.32 4.324 4.324 0 0 1 4.32-4.322 4.324 4.324 0 0 1 4.322 4.321zm-4.321-10.804A4.324 4.324 0 0 1 11.157 9.4a4.324 4.324 0 0 1 4.32-4.32A4.324 4.324 0 0 1 19.8 9.4a4.324 4.324 0 0 1-4.321 4.322z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlm);
export default __webpack_public_path__ + "static/media/GLM.13b534b43624eee895d839c038ede036.svg";
export { ForwardRef as ReactComponent };